<div class="input-group mb-3 has-validation" [ngClass]="{'d-none': props.hidden}">
    <div class="form-floating" [class.is-invalid]="showError">
        <app-file-selection [field]="field" [props]="props" [formControl]="formControl" [formlyAttributes]="field" [label]="props.label" [requiredField]="props.required" [showError]="showError" />
    </div>
    <div *ngIf="showError" class="invalid-feedback" style="display: block;">
        <formly-validation-message [field]="field"></formly-validation-message>
    </div>
</div>